import {Action} from '@ngrx/store';
import * as  apiVeranstaltungen from '../../../../clients/veranstaltungen';


export const PAGE_STATE_RESET = '[FunktionsbereichChecklistenAufgabenPage] Page State reset';
export const SETZE_CHECKLISTE = '[FunktionsbereichChecklistenAufgabenPage] Setze Checkliste';
export const SETZE_FUNKTIONSBEREICH = '[FunktionsbereichChecklistenAufgabenPage] Setze Funktionsbereich';
export const SETZE_CURRENT_SLIDE_INDEX = '[FunktionsbereichChecklistenAufgabenPage] Setze aktuellen Slide Index';
export const IGNORE_WS_ACTION = '[FunktionsbereichChecklistenAufgabenPage] WS Action ignoriert';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// IGNORE WS ACTION
export class IgnoreWSAction implements Action {
    readonly type = IGNORE_WS_ACTION;

    constructor(public payload: any) {
    }
}

// BENUTZER
export class SetzeFunktionsbereichAction implements Action {
    readonly type = SETZE_FUNKTIONSBEREICH;

    constructor(public funktionsbereich: apiVeranstaltungen.Funktionsbereich) {
    }
}

export class SetzeChecklisteAction implements Action {
    readonly type = SETZE_CHECKLISTE;

    constructor(public checkliste: apiVeranstaltungen.Checkliste) {
    }
}

export class SetzeCurrentSlideIndexAction implements Action {
    readonly type = SETZE_CURRENT_SLIDE_INDEX;

    constructor(public index: number) {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    SetzeFunktionsbereichAction
    | SetzeChecklisteAction
    | SetzeCurrentSlideIndexAction
    | PageStateResetAction
    | IgnoreWSAction
    ;
